/*******************************************************
SEARCH FOR PLAYERS
Searches for players and returns the results.
********************************************************/

import showErrorNotificationBar from '../universal/error-handling/show-error-notification-bar';

export default async function searchPlayers(settings) {
    try {
        const response = await $.ajax({
            type   : 'GET',
            url    : '/frontend/ajax/search-players.php',
            data   : settings,
            timeout: 8000,
        });

        // Check for errors with the data
        if (response.error || !response.success) { throw new Error(response.error); }

        // Return the data
        return {
            players: response.players,
        };
    }
    catch (error) {
        showErrorNotificationBar(error.message || 'We were unable to search for players. Please try again.', 3000);
    }
}
